/**
 * DOM Element Cache
 * Centralized DOM element references for the application
 */

export const elements = {
  // Canvas elements
  canvas: null,
  lyricsOverlayCanvas: null,
  lyricsOverlayCtx: null,

  // Icon sidebar
  iconSidebar: null,
  visualizerBtn: null,
  playlistBtn: null,
  exportIconBtn: null,
  liveIconBtn: null,
  settingsBtn: null,

  // Overlay panels
  overlayBackdrop: null,
  visualizerPanel: null,
  playlistPanel: null,
  exportPanel: null,
  settingsOverlay: null,
  settingsCollapseBtn: null,

  // Drop modal
  dropModal: null,
  dropModalClose: null,
  dropZone: null,
  fileInput: null,
  folderInput: null,
  selectFilesBtn: null,
  selectFolderBtn: null,

  // Transport bar
  transportBar: null,
  playPauseBtn: null,
  seekBar: null,
  currentTimeEl: null,
  durationEl: null,
  fileNameEl: null,
  trackInfoEl: null,
  transportTrackInfo: null,
  prevTrackBtn: null,
  nextTrackBtn: null,

  // Visualizer grid
  visualizerGrid: null,
  dynamicControlsEl: null,

  // Legacy visualizer controls (for compatibility)
  vizTypeSelect: null,

  // Playlist elements
  playlistContainer: null,
  playlistItems: null,
  playlistCount: null,
  playlistHeader: null,
  playlistContent: null,

  // Playlist duration display
  playlistTotalDuration: null,
  playlistDurationText: null,
  playlistOverlayDuration: null,

  // Playlist overlay elements
  playlistOverlay: null,
  playlistOverlayContainer: null,
  playlistOverlayList: null,
  playlistOverlayCount: null,
  playlistTriggerBtn: null,
  bulkExcludeBtn: null,
  cleanUpBtn: null,
  toggleExcludedBtn: null,
  excludedBadge: null,
  collapsePlaylistOverlayBtn: null,
  playlistOverlayExcluded: null,
  excludedList: null,
  excludedCount: null,
  closeExcludedBtn: null,

  // Playlist sorting elements
  playlistSortToggles: null,
  sortCustomBtn: null,
  sortAlphaBtn: null,
  sortDateBtn: null,
  sortDurationBtn: null,

  // Playlist filter elements
  playlistFilterInput: null,
  playlistFilterClear: null,
  playlistFilterContainer: null,

  // Suno metadata filter elements
  sunoFilterDropdown: null,
  sunoFilterBtn: null,
  sunoFilterBadge: null,
  sunoFilterPanel: null,
  sunoFilterClearAll: null,
  sunoFilterGenre: null,
  sunoFilterTheme: null,
  sunoFilterDateFrom: null,
  sunoFilterDateTo: null,

  // Current song display in overlay header
  playlistCurrentSong: null,
  currentSongName: null,

  // Overlay lyrics panel elements
  playlistOverlayLyrics: null,
  lyricsOverlayTrack: null,
  lyricsOverlayText: null,
  lyricsOverlayDropzone: null,
  lyricsOverlayActions: null,
  lyricsOverlayFileInput: null,
  closeLyricsOverlayBtn: null,
  swapLyricsOverlayBtn: null,
  clearLyricsOverlayBtn: null,
  lyricsOverlaySelectBtn: null,

  // Export controls
  exportControls: null,
  exportBtn: null,
  resolutionSelect: null,
  fpsSelect: null,
  exportCodecSelect: null,
  exportBitrateSelect: null,
  // Segmented controls (visible UI for settings)
  resolutionControl: null,
  fpsControl: null,
  bitrateControl: null,
  codecCards: null,
  exportProgress: null,
  progressBar: null,
  progressText: null,
  exportLocation: null,
  exportCurrentSong: null,
  exportFileSize: null,
  exportFpsInfo: null,
  exportEtaInfo: null,
  // Export playlist summary
  exportPlaylistSummary: null,
  exportSongsToExport: null,
  exportSongsExcluded: null,
  exportSongsMissingLyrics: null,
  // Export preview overlay
  exportPreviewOverlay: null,

  // Inline export controls (within transport bar during export)
  transportControls: null,
  transportExportControls: null,
  exportInlineTrackName: null,
  exportInlineProgressFill: null,
  exportInlineProgressText: null,
  exportInlineFps: null,
  exportInlineEta: null,
  exportInlineSize: null,
  exportInlineStopBtn: null,

  // Lyrics settings (in settings overlay)
  lyricsPanel: null,
  lyricsPanelTrack: null,
  lyricsPanelText: null,
  lyricsFileInput: null,

  // Presets (in settings overlay)
  presetSelect: null,
  presetNameInput: null,

  // Mode buttons (legacy, now in icon sidebar)
  theaterModeBtn: null,
  fullscreenBtn: null,
  liveModeBtn: null,
  liveMonitorLabel: null,
  liveMonitorCheckbox: null,

  // Legacy audio controls container
  audioControls: null,

  // Library browser panel elements
  libraryPanel: null,
  librarySearchInput: null,
  librarySearchClear: null,
  libraryGrid: null,
  libraryList: null,
  libraryLoading: null,
  libraryEmpty: null,
  libraryEmptyMessage: null,
  libraryError: null,
  libraryErrorMessage: null,
  libraryRetryBtn: null,
  libraryContent: null,
  libraryLoadMore: null,
  libraryLoadMoreBtn: null,
  librarySentinel: null,
  librarySelectionToolbar: null,
  librarySelectionCount: null,
  libraryClearSelectionBtn: null,
  librarySelectAllBtn: null,
  libraryAddSelectedBtn: null,
  libraryAddAllFilteredBtn: null,
  libraryPrimaryActionIcon: null,
  libraryPrimaryActionText: null,
  libraryWholeLibraryWrap: null,
  libraryWholeLibraryCheckbox: null,
  libraryAddAllProgress: null,
  libraryAddAllProgressText: null,
  libraryExportBtn: null,
  libraryExportMenu: null,
  libraryExtensionStatus: null,
  libraryRetryExtensionBtn: null,
  libraryExportProgress: null,
  libraryExportProgressText: null,
  libraryExportProgressBar: null,
  libraryExportCancelBtn: null,
  // Library browser advanced filter elements (Issue #7)
  libraryFilterToggle: null,
  libraryActiveFilters: null,
  libraryFilterBadges: null,
  libraryFilterPanel: null,
  libraryFilterGenre: null,
  libraryFilterTheme: null,
  libraryFilterDateFrom: null,
  libraryFilterDateTo: null,
  libraryFilterLength: null,  // Length filter input (Issue #13)

  // Generator panel elements
  generatorPanel: null,
  generatorForm: null,
  generatorGenre: null,
  generatorTheme: null,
  generatorSongCount: null,
  generatorAudioType: null,
  generateBtn: null,
  generatorProgress: null,
  generatorProgressBar: null,
  generatorProgressText: null,
  generatorSongList: null,
  cancelGenerationBtn: null,
  generatorCaptcha: null,
  openSunoBtn: null,
  resumeGenerationBtn: null,

  // Generator advanced options (Issue #7)
  advancedToggleBtn: null,
  advancedOptions: null,
  genreMixDropdown: null,
  selectedGenres: null,
  generatorMood: null,
  instrumentSelect: null,
  vocalOptions: null,
  vocalType: null,
  vocalStyle: null,
  styleInfluence: null,
  generatorEra: null,
  generatePromptBtn: null,
  generatedPromptContainer: null,
  generatedPrompt: null,
  usePromptBtn: null,
  lyricsOptions: null,
  generateLyricsCheckbox: null,
  lyricsForm: null,
  lyricsTheme: null,
  lyricsMood: null,
  lyricsStructure: null,
  generateLyricsBtn: null,
  generatedLyricsContainer: null,
  generatedLyrics: null,
  useLyricsBtn: null,

  // Fix prompt/lyrics checkboxes (Issue #10)
  fixPromptCheckbox: null,
  fixLyricsCheckbox: null,

  // Suno Manager (full-size interface)
  sunoManagerModal: null,
  sunoManagerCollapseBtn: null,
  sunoManagerCloseBtn: null,
  expandGeneratorBtn: null,
  expandLibraryBtn: null,
  collapseToGeneratorBtn: null,
  collapseToLibraryBtn: null,
  sunoManagerGeneratorContent: null,
  sunoManagerLibraryContent: null
};

/**
 * Cache all DOM element references
 * Called once during initialization
 */
export function cacheElements() {
  // Canvas elements
  elements.canvas = document.getElementById('visualizerCanvas');
  elements.lyricsOverlayCanvas = document.getElementById('lyricsOverlayCanvas');
  if (elements.lyricsOverlayCanvas) {
    elements.lyricsOverlayCtx = elements.lyricsOverlayCanvas.getContext('2d');
  }

  // Icon sidebar
  elements.iconSidebar = document.querySelector('.icon-sidebar');
  elements.visualizerBtn = document.querySelector('.icon-btn[data-panel="visualizer"]');
  elements.playlistBtn = document.querySelector('.icon-btn[data-panel="playlist"]');
  elements.exportIconBtn = document.querySelector('.icon-btn[data-panel="export"]');
  elements.liveIconBtn = document.querySelector('.icon-btn[data-action="live"]');
  elements.settingsBtn = document.querySelector('.icon-btn[data-panel="settings"]');

  // Overlay panels
  elements.overlayBackdrop = document.getElementById('overlayBackdrop');
  elements.visualizerPanel = document.getElementById('visualizerPanel');
  elements.playlistPanel = document.getElementById('playlistPanel');
  elements.exportPanel = document.getElementById('exportPanel');
  elements.settingsOverlay = document.getElementById('settingsOverlay');
  elements.settingsCollapseBtn = document.querySelector('.settings-collapse-btn');

  // Drop modal
  elements.dropModal = document.getElementById('dropModal');
  elements.dropModalClose = elements.dropModal?.querySelector('.modal-close');
  elements.dropZone = document.getElementById('dropZone');
  elements.fileInput = document.getElementById('fileInput');
  elements.folderInput = document.getElementById('folderInput');
  elements.selectFilesBtn = document.getElementById('selectFilesBtn');
  elements.selectFolderBtn = document.getElementById('selectFolderBtn');

  // Transport bar
  elements.transportBar = document.getElementById('transportBar');
  elements.playPauseBtn = document.getElementById('playPauseBtn');
  elements.seekBar = document.getElementById('seekBar');
  elements.currentTimeEl = document.getElementById('currentTime');
  elements.durationEl = document.getElementById('duration');
  elements.fileNameEl = document.getElementById('fileName');
  elements.trackInfoEl = document.getElementById('trackInfo');
  elements.transportTrackInfo = document.getElementById('transportTrackInfo');
  elements.prevTrackBtn = document.getElementById('prevTrackBtn');
  elements.nextTrackBtn = document.getElementById('nextTrackBtn');

  // Visualizer grid (new UI uses vizSelectorGrid)
  elements.visualizerGrid = document.getElementById('vizSelectorGrid') || document.getElementById('visualizerGrid');
  elements.dynamicControlsEl = document.getElementById('dynamicControls');

  // Legacy visualizer controls (for compatibility)
  elements.vizTypeSelect = document.getElementById('visualizationType');

  // Playlist elements
  elements.playlistContainer = document.getElementById('playlistContainer');
  elements.playlistItems = document.getElementById('playlistItems');
  elements.playlistCount = document.getElementById('playlistCount');
  elements.playlistHeader = document.getElementById('playlistHeader');
  elements.playlistContent = document.getElementById('playlistContent');

  // Playlist duration display
  elements.playlistTotalDuration = document.getElementById('playlistTotalDuration');
  elements.playlistDurationText = document.getElementById('playlistDurationText');
  elements.playlistOverlayDuration = document.getElementById('playlistOverlayDuration');

  // Playlist overlay elements
  elements.playlistOverlay = document.getElementById('playlistOverlay');
  elements.playlistOverlayContainer = document.getElementById('playlistOverlayContainer');
  elements.playlistOverlayList = document.getElementById('playlistOverlayList');
  elements.playlistOverlayCount = document.getElementById('playlistOverlayCount');
  elements.playlistTriggerBtn = document.getElementById('playlistTriggerBtn');
  elements.bulkExcludeBtn = document.getElementById('bulkExcludeBtn');
  elements.cleanUpBtn = document.getElementById('cleanUpBtn');
  elements.toggleExcludedBtn = document.getElementById('toggleExcludedBtn');
  elements.excludedBadge = document.getElementById('excludedBadge');
  elements.collapsePlaylistOverlayBtn = document.getElementById('collapsePlaylistOverlayBtn');
  elements.playlistOverlayExcluded = document.getElementById('playlistOverlayExcluded');
  elements.excludedList = document.getElementById('excludedList');
  elements.excludedCount = document.getElementById('excludedCount');
  elements.closeExcludedBtn = document.getElementById('closeExcludedBtn');

  // Playlist sorting elements
  elements.playlistSortToggles = document.getElementById('playlistSortToggles');
  elements.sortCustomBtn = document.getElementById('sortCustomBtn');
  elements.sortAlphaBtn = document.getElementById('sortAlphaBtn');
  elements.sortDateBtn = document.getElementById('sortDateBtn');
  elements.sortDurationBtn = document.getElementById('sortDurationBtn');

  // Playlist filter elements
  elements.playlistFilterInput = document.getElementById('playlistFilterInput');
  elements.playlistFilterClear = document.getElementById('playlistFilterClear');
  elements.playlistFilterContainer = document.getElementById('playlistFilterContainer');

  // Suno metadata filter elements
  elements.sunoFilterDropdown = document.getElementById('sunoFilterDropdown');
  elements.sunoFilterBtn = document.getElementById('sunoFilterBtn');
  elements.sunoFilterBadge = document.getElementById('sunoFilterBadge');
  elements.sunoFilterPanel = document.getElementById('sunoFilterPanel');
  elements.sunoFilterClearAll = document.getElementById('sunoFilterClearAll');
  elements.sunoFilterGenre = document.getElementById('sunoFilterGenre');
  elements.sunoFilterTheme = document.getElementById('sunoFilterTheme');
  elements.sunoFilterDateFrom = document.getElementById('sunoFilterDateFrom');
  elements.sunoFilterDateTo = document.getElementById('sunoFilterDateTo');

  // Current song display in overlay header
  elements.playlistCurrentSong = document.getElementById('playlistCurrentSong');
  elements.currentSongName = document.getElementById('currentSongName');

  // Overlay lyrics panel elements
  elements.playlistOverlayLyrics = document.getElementById('playlistOverlayLyrics');
  elements.lyricsOverlayTrack = document.getElementById('lyricsOverlayTrack');
  elements.lyricsOverlayText = document.getElementById('lyricsOverlayText');
  elements.lyricsOverlayDropzone = document.getElementById('lyricsOverlayDropzone');
  elements.lyricsOverlayActions = document.getElementById('lyricsOverlayActions');
  elements.lyricsOverlayFileInput = document.getElementById('lyricsOverlayFileInput');
  elements.closeLyricsOverlayBtn = document.getElementById('closeLyricsOverlayBtn');
  elements.swapLyricsOverlayBtn = document.getElementById('swapLyricsOverlayBtn');
  elements.clearLyricsOverlayBtn = document.getElementById('clearLyricsOverlayBtn');
  elements.lyricsOverlaySelectBtn = document.getElementById('lyricsOverlaySelectBtn');

  // Export controls
  elements.exportControls = document.getElementById('exportControls');
  elements.exportBtn = document.getElementById('exportBtn');
  elements.resolutionSelect = document.getElementById('resolution');
  elements.fpsSelect = document.getElementById('exportFps');
  elements.exportCodecSelect = document.getElementById('exportCodec');
  elements.exportBitrateSelect = document.getElementById('exportBitrate');
  // Segmented controls
  elements.resolutionControl = document.getElementById('resolutionControl');
  elements.fpsControl = document.getElementById('fpsControl');
  elements.bitrateControl = document.getElementById('bitrateControl');
  elements.codecCards = document.getElementById('codecCards');
  elements.exportProgress = document.getElementById('exportProgress');
  elements.progressBar = document.getElementById('progressBar');
  elements.progressText = document.getElementById('progressText');
  elements.exportLocation = document.getElementById('exportLocation');
  elements.exportCurrentSong = document.getElementById('exportCurrentSong');
  elements.exportFileSize = document.getElementById('exportFileSize');
  elements.exportFpsInfo = document.getElementById('exportFpsInfo');
  elements.exportEtaInfo = document.getElementById('exportEtaInfo');

  // Export playlist summary
  elements.exportPlaylistSummary = document.getElementById('exportPlaylistSummary');
  elements.exportSongsToExport = document.getElementById('exportSongsToExport');
  elements.exportSongsExcluded = document.getElementById('exportSongsExcluded');
  elements.exportSongsMissingLyrics = document.getElementById('exportSongsMissingLyrics');

  // Export preview overlay
  elements.exportPreviewOverlay = document.getElementById('exportPreviewOverlay');

  // Inline export controls (within transport bar during export)
  elements.transportControls = document.getElementById('transportControls');
  elements.transportExportControls = document.getElementById('transportExportControls');
  elements.exportInlineTrackName = document.getElementById('exportInlineTrackName');
  elements.exportInlineProgressFill = document.getElementById('exportInlineProgressFill');
  elements.exportInlineProgressText = document.getElementById('exportInlineProgressText');
  elements.exportInlineFps = document.getElementById('exportInlineFps');
  elements.exportInlineEta = document.getElementById('exportInlineEta');
  elements.exportInlineSize = document.getElementById('exportInlineSize');
  elements.exportInlineStopBtn = document.getElementById('exportInlineStopBtn');

  // Lyrics settings
  elements.lyricsPanel = document.getElementById('lyricsPanel');
  elements.lyricsPanelTrack = document.getElementById('lyricsPanelTrack');
  elements.lyricsPanelText = document.getElementById('lyricsPanelText');
  elements.lyricsFileInput = document.getElementById('lyricsFileInput');

  // Presets
  elements.presetSelect = document.getElementById('presetSelect');
  elements.presetNameInput = document.getElementById('presetName');

  // Mode buttons (legacy)
  elements.theaterModeBtn = document.getElementById('theaterModeBtn');
  elements.fullscreenBtn = document.getElementById('fullscreenBtn');
  elements.liveModeBtn = document.getElementById('liveModeBtn');
  elements.liveMonitorLabel = document.getElementById('liveMonitorLabel');
  elements.liveMonitorCheckbox = document.getElementById('liveMonitorCheckbox');

  // Legacy audio controls container
  elements.audioControls = document.getElementById('audioControls');

  // Library browser panel elements
  elements.libraryPanel = document.getElementById('libraryPanel');
  elements.librarySearchInput = document.getElementById('librarySearchInput');
  elements.librarySearchClear = document.getElementById('librarySearchClear');
  elements.libraryGrid = document.getElementById('libraryGrid');
  elements.libraryList = document.getElementById('libraryList');
  elements.libraryLoading = document.getElementById('libraryLoading');
  elements.libraryEmpty = document.getElementById('libraryEmpty');
  elements.libraryEmptyMessage = document.getElementById('libraryEmptyMessage');
  elements.libraryError = document.getElementById('libraryError');
  elements.libraryErrorMessage = document.getElementById('libraryErrorMessage');
  elements.libraryRetryBtn = document.getElementById('libraryRetryBtn');
  elements.libraryContent = document.getElementById('libraryContent');
  elements.libraryLoadMore = document.getElementById('libraryLoadMore');
  elements.libraryLoadMoreBtn = document.getElementById('libraryLoadMoreBtn');
  elements.librarySentinel = document.getElementById('librarySentinel');
  elements.librarySelectionToolbar = document.getElementById('librarySelectionToolbar');
  elements.librarySelectionCount = document.getElementById('librarySelectionCount');
  elements.libraryClearSelectionBtn = document.getElementById('libraryClearSelectionBtn');
  elements.librarySelectAllBtn = document.getElementById('librarySelectAllBtn');
  elements.libraryAddSelectedBtn = document.getElementById('libraryAddSelectedBtn');
  elements.libraryAddAllFilteredBtn = document.getElementById('libraryAddAllFilteredBtn');
  elements.libraryPrimaryActionIcon = document.getElementById('libraryPrimaryActionIcon');
  elements.libraryPrimaryActionText = document.getElementById('libraryPrimaryActionText');
  elements.libraryWholeLibraryWrap = document.getElementById('libraryWholeLibraryWrap');
  elements.libraryWholeLibraryCheckbox = document.getElementById('libraryWholeLibraryCheckbox');
  elements.libraryAddAllProgress = document.getElementById('libraryAddAllProgress');
  elements.libraryAddAllProgressText = document.getElementById('libraryAddAllProgressText');
  elements.libraryExportBtn = document.getElementById('libraryExportBtn');
  elements.libraryExportMenu = document.getElementById('libraryExportMenu');
  elements.libraryExtensionStatus = document.getElementById('libraryExtensionStatus');
  elements.libraryRetryExtensionBtn = document.getElementById('libraryRetryExtensionBtn');
  elements.libraryExportProgress = document.getElementById('libraryExportProgress');
  elements.libraryExportProgressText = document.getElementById('libraryExportProgressText');
  elements.libraryExportProgressBar = document.getElementById('libraryExportProgressBar');
  elements.libraryExportCancelBtn = document.getElementById('libraryExportCancelBtn');
  // Library browser advanced filter elements (Issue #7)
  elements.libraryFilterToggle = document.getElementById('libraryFilterToggle');
  elements.libraryActiveFilters = document.getElementById('libraryActiveFilters');
  elements.libraryFilterBadges = document.getElementById('libraryFilterBadges');
  elements.libraryFilterPanel = document.getElementById('libraryFilterPanel');
  elements.libraryFilterGenre = document.getElementById('libraryFilterGenre');
  elements.libraryFilterTheme = document.getElementById('libraryFilterTheme');
  elements.libraryFilterDateFrom = document.getElementById('libraryFilterDateFrom');
  elements.libraryFilterDateTo = document.getElementById('libraryFilterDateTo');
  elements.libraryFilterLength = document.getElementById('libraryFilterLength');

  // Generator panel elements
  elements.generatorPanel = document.getElementById('generatorPanel');
  elements.generatorForm = document.getElementById('generatorForm');
  elements.generatorGenre = document.getElementById('generatorGenre');
  elements.generatorTheme = document.getElementById('generatorTheme');
  elements.generatorSongCount = document.getElementById('generatorSongCount');
  elements.generatorAudioType = document.getElementById('generatorAudioType');
  elements.generateBtn = document.getElementById('generateBtn');
  elements.generatorProgress = document.getElementById('generatorProgress');
  elements.generatorProgressBar = document.getElementById('generatorProgressBar');
  elements.generatorProgressText = document.getElementById('generatorProgressText');
  elements.generatorSongList = document.getElementById('generatorSongList');
  elements.cancelGenerationBtn = document.getElementById('cancelGenerationBtn');
  elements.generatorCaptcha = document.getElementById('generatorCaptcha');
  elements.openSunoBtn = document.getElementById('openSunoBtn');
  elements.resumeGenerationBtn = document.getElementById('resumeGenerationBtn');

  // Generator advanced options (Issue #7)
  elements.advancedToggleBtn = document.getElementById('advancedToggleBtn');
  elements.advancedOptions = document.getElementById('advancedOptions');
  elements.genreMixDropdown = document.getElementById('genreMixDropdown');
  elements.selectedGenres = document.getElementById('selectedGenres');
  elements.generatorMood = document.getElementById('generatorMood');
  elements.instrumentSelect = document.getElementById('instrumentSelect');
  elements.vocalOptions = document.getElementById('vocalOptions');
  elements.vocalType = document.getElementById('vocalType');
  elements.vocalStyle = document.getElementById('vocalStyle');
  elements.styleInfluence = document.getElementById('styleInfluence');
  elements.generatorEra = document.getElementById('generatorEra');
  elements.generatePromptBtn = document.getElementById('generatePromptBtn');
  elements.generatedPromptContainer = document.getElementById('generatedPromptContainer');
  elements.generatedPrompt = document.getElementById('generatedPrompt');
  elements.usePromptBtn = document.getElementById('usePromptBtn');
  elements.lyricsOptions = document.getElementById('lyricsOptions');
  elements.generateLyricsCheckbox = document.getElementById('generateLyricsCheckbox');
  elements.lyricsForm = document.getElementById('lyricsForm');
  elements.lyricsTheme = document.getElementById('lyricsTheme');
  elements.lyricsMood = document.getElementById('lyricsMood');
  elements.lyricsStructure = document.getElementById('lyricsStructure');
  elements.generateLyricsBtn = document.getElementById('generateLyricsBtn');
  elements.generatedLyricsContainer = document.getElementById('generatedLyricsContainer');
  elements.generatedLyrics = document.getElementById('generatedLyrics');
  elements.useLyricsBtn = document.getElementById('useLyricsBtn');

  // Fix prompt/lyrics checkboxes (Issue #10)
  elements.fixPromptCheckbox = document.getElementById('fixPromptCheckbox');
  elements.fixLyricsCheckbox = document.getElementById('fixLyricsCheckbox');

  // Suno Manager (full-size interface)
  elements.sunoManagerModal = document.getElementById('sunoManagerModal');
  elements.sunoManagerCollapseBtn = document.getElementById('sunoManagerCollapseBtn');
  elements.sunoManagerCloseBtn = document.getElementById('sunoManagerCloseBtn');
  elements.expandGeneratorBtn = document.getElementById('expandGeneratorBtn');
  elements.expandLibraryBtn = document.getElementById('expandLibraryBtn');
  elements.collapseToGeneratorBtn = document.getElementById('collapseToGeneratorBtn');
  elements.collapseToLibraryBtn = document.getElementById('collapseToLibraryBtn');
  elements.sunoManagerGeneratorContent = document.getElementById('sunoManagerGeneratorContent');
  elements.sunoManagerLibraryContent = document.getElementById('sunoManagerLibraryContent');
}
